import { FC, SVGAttributes } from 'react';

const FilledInfo: FC<SVGAttributes<SVGElement>> = (props) => {
    return (
        <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M8 1C11.871 1 15 4.1367 15 8C15 11.8647 11.871 15 8 15C4.136 15 1 11.8647 1 8C1 4.1367 4.136 1 8 1ZM8.00391 6.87988C7.64492 6.87988 7.35352 7.17129 7.35352 7.53027V11.1973C7.35369 11.5561 7.64503 11.8467 8.00391 11.8467C8.36256 11.8464 8.65412 11.5559 8.6543 11.1973V7.53027C8.6543 7.17145 8.36267 6.88015 8.00391 6.87988ZM8 4.25C7.58579 4.25 7.25 4.58579 7.25 5C7.25 5.41421 7.58579 5.75 8 5.75H8.00684C8.42097 5.74991 8.75684 5.41416 8.75684 5C8.75684 4.58584 8.42097 4.25009 8.00684 4.25H8Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default FilledInfo;
